import { cx } from '@linaria/core';
import { useState } from 'react';
import { inputGroupWrapperCls, circleCls, labelCls } from './atom.speed-input.style.js';
import { jsx } from 'react/jsx-runtime';

const SpeedInput = ({
  activeSpeed,
  steps,
  onSpeedChange
}) => {
  const [hoveredSpeed, setHoveredSpeed] = useState(undefined);
  const maxActiveSpeed = hoveredSpeed ?? activeSpeed;
  const onMouseLeave = () => {
    setHoveredSpeed(undefined);
  };
  const onMouseEnterInput = index => {
    setHoveredSpeed(index);
  };
  const inputs = [];
  for (let i = 0; i < steps; i++) {
    inputs.push(/*#__PURE__*/jsx(Input, {
      index: i,
      active: i <= maxActiveSpeed,
      checked: i === activeSpeed,
      onChange: onSpeedChange,
      onHovered: onMouseEnterInput
    }, `SpeedInput-${i}`));
  }
  return /*#__PURE__*/jsx("div", {
    className: inputGroupWrapperCls,
    onMouseLeave: onMouseLeave,
    children: inputs
  });
};
const Input = ({
  index,
  active,
  checked,
  onHovered,
  onChange
}) => {
  const id = `SpeedInput-${index}`;
  const onToggled = () => {
    onChange(index);
  };
  const onMouseEnter = () => {
    onHovered(index);
  };
  return /*#__PURE__*/jsx("label", {
    htmlFor: id,
    className: cx(labelCls, active && "active", checked && "checked"),
    "aria-label": `Hastighed ${index}`,
    onMouseEnter: onMouseEnter,
    children: /*#__PURE__*/jsx("div", {
      className: circleCls,
      children: /*#__PURE__*/jsx("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: onToggled
      })
    })
  });
};

export { SpeedInput };
//# sourceMappingURL=atom.speed-input.js.map
